// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Kd99P_em_nR1DCkxzA3 {
    padding: 24px 28px 20px;
    font-family: var(--curio-font-family);
    color: var(--curio-text-primary);
    background: var(--curio-page-bg);
}

.pLrilEbf2R4SxJLvtnP8 {
    margin: 0 32px 6px 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--curio-text-primary);
}

.g1riNQ0a1OgVBacBatug {
    margin: 0 0 16px;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-secondary);
    line-height: 1.4;
}

.wLZsIuy0zieTbK423XA4 {
    display: block;
    font-size: var(--curio-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--curio-text-muted);
    margin-bottom: 6px;
}

.AKFwnDLpMdKhR5LjUP3U {
    position: relative;
    margin-bottom: 12px;
}

.eV4P9sG01tQISXRcwDsW {
    width: 100%;
    box-sizing: border-box;
    appearance: none;
    padding: 10px 36px 10px 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    font: inherit;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-primary);
    cursor: pointer;
}

.eV4P9sG01tQISXRcwDsW:focus {
    outline: none;
    border-color: var(--curio-top-bar-bg);
}

.ggIb0LxIKi4Vj5TyuHzq {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    font-size: 0.65rem;
    color: var(--curio-text-muted);
}

.hLhoRbCYmbve0TP9cr0R {
    margin: 0 0 16px;
    padding: 10px 12px;
    border-radius: var(--curio-radius-md);
    border: 1px solid var(--curio-role-update-fg);
    background: var(--curio-role-update-bg);
    font-size: var(--curio-font-size-sm);
    color: var(--curio-role-update-fg);
    line-height: 1.45;
}

.cxBsbYNJ28lDzHCXOAFx {
    margin: 0 0 16px;
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-muted);
    line-height: 1.45;
}

.zQZmC7eXPr90so0alMiv {
    margin-bottom: 16px;
}

.WTqrCVrFFUNHx0bTH4B5 {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-md);
}

.WTqrCVrFFUNHx0bTH4B5:focus {
    outline: none;
    border-color: var(--curio-top-bar-bg);
}

.AVazNa0YO5F1mg7xyxxt {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.yxH816NHFMej0BSZxRlO {
    padding: 0 16px;
    height: var(--curio-input-height);
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-lg);
    font-weight: 500;
    cursor: pointer;
}

.yxH816NHFMej0BSZxRlO:hover:not(:disabled) {
    background: var(--curio-page-bg);
}

.CmCqH8mICXy18y9fYLtQ {
    padding: 0 20px;
    height: var(--curio-input-height);
    border: none;
    border-radius: var(--curio-radius-md);
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    font: inherit;
    font-size: var(--curio-font-size-lg);
    font-weight: 600;
    cursor: pointer;
}

.CmCqH8mICXy18y9fYLtQ:hover:not(:disabled) {
    background: var(--curio-top-bar-bg-hover);
}

.CmCqH8mICXy18y9fYLtQ:disabled,
.yxH816NHFMej0BSZxRlO:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/editing/NodeSaveAsModal.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B;IAC5B,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,6CAA6C;IAC7C,uCAAuC;IACvC,oCAAoC;IACpC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".content {\n    padding: 24px 28px 20px;\n    font-family: var(--curio-font-family);\n    color: var(--curio-text-primary);\n    background: var(--curio-page-bg);\n}\n\n.title {\n    margin: 0 32px 6px 0;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--curio-text-primary);\n}\n\n.subtitle {\n    margin: 0 0 16px;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-secondary);\n    line-height: 1.4;\n}\n\n.fieldLabel {\n    display: block;\n    font-size: var(--curio-font-size-xs);\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--curio-text-muted);\n    margin-bottom: 6px;\n}\n\n.selectWrap {\n    position: relative;\n    margin-bottom: 12px;\n}\n\n.select {\n    width: 100%;\n    box-sizing: border-box;\n    appearance: none;\n    padding: 10px 36px 10px 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-primary);\n    cursor: pointer;\n}\n\n.select:focus {\n    outline: none;\n    border-color: var(--curio-top-bar-bg);\n}\n\n.selectChevron {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none;\n    font-size: 0.65rem;\n    color: var(--curio-text-muted);\n}\n\n.warning {\n    margin: 0 0 16px;\n    padding: 10px 12px;\n    border-radius: var(--curio-radius-md);\n    border: 1px solid var(--curio-role-update-fg);\n    background: var(--curio-role-update-bg);\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-role-update-fg);\n    line-height: 1.45;\n}\n\n.hint {\n    margin: 0 0 16px;\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-muted);\n    line-height: 1.45;\n}\n\n.newPackageField {\n    margin-bottom: 16px;\n}\n\n.input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 10px 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n}\n\n.input:focus {\n    outline: none;\n    border-color: var(--curio-top-bar-bg);\n}\n\n.footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.ghostBtn {\n    padding: 0 16px;\n    height: var(--curio-input-height);\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.ghostBtn:hover:not(:disabled) {\n    background: var(--curio-page-bg);\n}\n\n.primaryBtn {\n    padding: 0 20px;\n    height: var(--curio-input-height);\n    border: none;\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.primaryBtn:hover:not(:disabled) {\n    background: var(--curio-top-bar-bg-hover);\n}\n\n.primaryBtn:disabled,\n.ghostBtn:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `_Kd99P_em_nR1DCkxzA3`,
	"title": `pLrilEbf2R4SxJLvtnP8`,
	"subtitle": `g1riNQ0a1OgVBacBatug`,
	"fieldLabel": `wLZsIuy0zieTbK423XA4`,
	"selectWrap": `AKFwnDLpMdKhR5LjUP3U`,
	"select": `eV4P9sG01tQISXRcwDsW`,
	"selectChevron": `ggIb0LxIKi4Vj5TyuHzq`,
	"warning": `hLhoRbCYmbve0TP9cr0R`,
	"hint": `cxBsbYNJ28lDzHCXOAFx`,
	"newPackageField": `zQZmC7eXPr90so0alMiv`,
	"input": `WTqrCVrFFUNHx0bTH4B5`,
	"footer": `AVazNa0YO5F1mg7xyxxt`,
	"ghostBtn": `yxH816NHFMej0BSZxRlO`,
	"primaryBtn": `CmCqH8mICXy18y9fYLtQ`
};
export default ___CSS_LOADER_EXPORT___;
